import Skeleton from "react-loading-skeleton";

const CashierDetailsSkeleton = () => {
  return (
    <div className="flex flex-col gap-[12px] mt-[20px] mr-[16px]">
      <div className="flex flex-col py-[8px] px-[12px] space-y-[12px] border border-border-subtle bg-bg-base rounded-lg">
        {/* Trade Header */}
        <div className="flex flex-row justify-between">
          <Skeleton height={20} width={100} />
          <Skeleton height={20} width={50} />
        </div>

        <div className="flex flex-row justify-between items-center">
          <span className="text-[12px]">Username</span>
          <Skeleton height={10} width={100} />
        </div>

        <div className="flex flex-row justify-between items-center">
          <span className="text-[12px]">Tylt Email</span>
          <Skeleton height={10} width={100} />
        </div>

        <div className="flex flex-row justify-between items-center">
          <span className="text-[12px]">Area Manager</span>
          <Skeleton height={10} width={100} />
        </div>

        <div className="flex flex-row justify-between items-center">
          <span className="text-[12px]">UPI IDs</span>
          <Skeleton height={10} width={100} />
        </div>
      </div>

      <div className="flex flex-col py-[8px] px-[12px] space-y-[12px] border border-border-subtle bg-bg-base rounded-lg">
        <div className="flex flex-row justify-between items-center">
          <span className="text-[12px]">Current USDT Balance</span>
          <Skeleton height={10} width={100} />
        </div>

        <div className="flex flex-row justify-between items-center">
          <span className="text-[12px]">Total Trade Value Completed (day)</span>
          <Skeleton circle height={16} width={16} />
        </div>

        <div className="flex flex-row justify-between items-center">
          <span className="text-[12px]">Total USDT in Escrow</span>
          <Skeleton height={10} width={100} />
        </div>

        {/* Refund Amount */}
        <div className="flex flex-row justify-between items-center">
          <span className="text-[12px]">Number of Order Fulfilled Daily</span>
          <Skeleton height={10} width={100} />
        </div>
      </div>

      <div className="flex flex-col py-[8px] px-[12px] space-y-[12px] border border-border-subtle bg-bg-base rounded-lg">
        {/* Action Buttons */}
        <div className="flex flex-row justify-between items-center">
          <Skeleton height={24} width={100} />
          <Skeleton height={24} width={100} />
        </div>
      </div>
    </div>
  );
};

export default CashierDetailsSkeleton;
